// Sentry settings shared by browser, server and edge. ERRORS ONLY:
// - no performance tracing (tracesSampleRate 0)
// - no session replay (no replayIntegration — reps' screens show customer
//   names and notes)
// - no personal or request data: no user info, cookies, headers, query params,
//   request/response bodies (server-action bodies carry rep notes), DB query
//   data or local variables.
// No DSN = Sentry is never initialised, so local dev and the mini send nothing.

import type { BrowserOptions } from "@sentry/nextjs";

export function sentryDsn(): string | undefined {
  return process.env.NEXT_PUBLIC_SENTRY_DSN || undefined;
}

export function sentryOptions(dsn: string): BrowserOptions {
  return {
    dsn,
    environment: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT || process.env.NODE_ENV,
    tracesSampleRate: 0,
    // v11 replaced `sendDefaultPii` with per-category `dataCollection`.
    dataCollection: {
      userInfo: false,
      cookies: false,
      httpHeaders: false,
      httpBodies: [],
      urlQueryParams: false,
      databaseQueryData: false,
      stackFrameVariables: false,
      genAI: { inputs: false, outputs: false },
    },
  };
}
